import { Assessment, Goal } from "../types/goal";

export default function processGoalData(
  mockData: Goal[] | null | undefined,
  isPrimary: boolean = false
) {
  const processedData = {
    data: {
      [isPrimary ? "mainGoal" : "customGoals"]: {
        goals: {} as Record<string, Goal>,
        assessments: {} as Record<string, Assessment>,
        totalAssessment: 0,
      },
    },
  };

  (mockData ?? []).forEach((goal) => {
    if (!goal?.id) return;

    const goalType = isPrimary ? "mainGoal" : "customGoals";
    const goalBucket = processedData?.data?.[goalType];
    if (!goalBucket) return;

    // Process goal
    goalBucket.goals[goal.id] = {
      id: goal.id,
      name: goal?.name ?? "",
      type: goal?.type ?? "",
      tag: goal?.tag ?? "",
      role: goal?.role ?? "",
      status: goal?.status ?? "",
      isPrimary: goal?.isPrimary ?? 0,
      preAssessment: goal?.preAssessment,
      subGoals: goal?.subGoals,
      assessmentIds: [],
      goalScore: goal?.goalScore ?? null,
    };

    // Process subgoals and assessments
    goal?.subGoals?.forEach((subGoal) => {
      if (!subGoal) return;

      Object.entries(subGoal).forEach(([key, value]) => {
        if (!key?.startsWith("assessment_")) return;

        const assessment = value as Assessment | undefined;
        if (!assessment) return;

        goalBucket.assessments[key] =
          assessment?.action === "preview"
            ? {
                id: key,
                isNew: true,
                name: assessment?.name || "New Assessment",
                action: assessment?.action,
              }
            : {
                id: key,
                value: assessment?.value,
                date: assessment?.date,
                isNew: false,
                name: assessment?.name,
                action: assessment?.action,
                isInherited: assessment?.isInherited,
                isPrefilled: assessment?.isPrefilled,
                isEditable: assessment?.isEditable,
              };

        const goalEntry = goalBucket.goals[goal.id];
        if (goalEntry && !goalEntry.assessmentIds?.includes(key)) {
          goalEntry.assessmentIds.push(key);
        }
      });
    });
  });

  return processedData;
}
